// 处理表情

import emtion from "./emtion.js"

String.prototype.replaceAll = function (FindText, RepText) {
  return this.replace(new RegExp(FindText, "g"), RepText);
}

export default (content) => {
    if(content) {
        emtion.forEach( val => {
            if(content.indexOf("["+val.title+"]") != -1) {
              content = content.replaceAll(val.title,`<img class='emtion' src='${val.url}'/>`)
              content = content.replace(/\[|]/g,'')
            }
          })
      
          return content
    }else {
        return content
    }
    
  }


// WEBPACK FOOTER //
// ./src/assets/js/getEmtion.js